import { z } from "zod";

export const hotZoneCategorySchema = z.enum([
  "social_unrest",
  "crime",
  "corruption",
  "political_violence",
  "institutional_instability",
]);

export const hotZoneSchema = z.object({
  zone_id: z.string().min(1),
  geohash: z.string().min(1),
  centroid: z.object({
    lat: z.number().min(-90).max(90),
    lon: z.number().min(-180).max(180),
  }).strict(),
  category: hotZoneCategorySchema,
  intensity: z.number().min(0).max(100),
  trend: z.enum(["rising", "stable", "falling"]),
  event_count: z.number().int().nonnegative(),
  mention_count: z.number().int().nonnegative(),
  source_count: z.number().int().nonnegative().optional(),
  confidence: z.number().min(0).max(1).optional(),
  top_themes: z.array(z.string()),
  updated_at: z.string().datetime({ offset: true }),
}).passthrough();

export const globeFrameSchema = z.object({
  generated_at: z.string().datetime({ offset: true }),
  window_minutes: z.number().int().positive(),
  global_intensity: z.number().min(0).max(100),
  category_breakdown: z.object({
    social_unrest: z.number().nonnegative(),
    crime: z.number().nonnegative(),
    corruption: z.number().nonnegative(),
    political_violence: z.number().nonnegative(),
    institutional_instability: z.number().nonnegative(),
  }).strict(),
  zones: z.array(hotZoneSchema),
}).passthrough();
